module.exports = __webpack_public_path__ + "img/jingdong.8245e5d4.png";